import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { CountryModule, PaymentInstructionCodeModule, ServiceChargeDetailsModule } from '@nano/common/classifier';
import { FileUploadModule } from '@nano/common/file';
import { FinanceModule } from '@nano/common/finance';
import { ModalModule } from '@nano/common/modal';
import { TfaModule } from '@nano/core/tfa';
import { PaymentAdditionalInfoModule } from '@nano/payment-additional-info';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';

import { BankTransferModule } from './bank-transfer/bank-transfer.module';
import { CurrencyExchangeModule } from './currency-exchange/currency-exchange.module';
import { PaymentConfirmComponent } from './payment-confirm/payment-confirm.component';
import { PaymentHasBeenSavedComponent } from './payment-has-been-saved/payment-has-been-saved.component';
import { PaymentHasBeenSentComponent } from './payment-has-been-sent/payment-has-been-sent.component';
import { PaymentInProgressComponent } from './payment-in-progress/payment-in-progress.component';
import { PaymentComponent } from './payment.component';
import { AlertModule } from '@nano/common/alert';

@NgModule({
  imports: [
    NzCollapseModule,
    CommonModule,
    FileUploadModule,
    FinanceModule,
    ModalModule,
    PaymentAdditionalInfoModule,
    TfaModule,
    BankTransferModule,
    CurrencyExchangeModule,
    PaymentInstructionCodeModule,
    CountryModule,
    ServiceChargeDetailsModule,
    AlertModule
  ],
  declarations: [PaymentComponent, PaymentConfirmComponent, PaymentInProgressComponent, PaymentHasBeenSavedComponent, PaymentHasBeenSentComponent]
})
export class PaymentModule {}
